<template>
  <div class="container-fluid">
    <h1 class="xl">Помощь</h1>
  </div>
</template>

<script>
export default {
  name: 'help',
  data () {
    return {
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>